#import "../TravelAuthorizationListFields.graphql"
query TravelAuthorizationSearch(
  $isLinkSearch: Boolean
  $searchRequest: SearchRequestInput
  $first: Int
  $filter: TravelAuthorizationFilter
  $orderBy: [TravelAuthorizationsOrderBy!]
  $after: Cursor
  $isSigningSearch: Boolean
  $isHistorySearch: Boolean
  $isSearchAllData: Boolean
  $filterMultiStatusTypes: [Int]
) {
  travelAuthorizationSearch(
    isLinkSearch: $isLinkSearch
    searchRequest: $searchRequest
    first: $first
    filter: $filter
    orderBy: $orderBy
    after: $after
    isSigningSearch: $isSigningSearch
    isHistorySearch: $isHistorySearch
    isSearchAllData: $isSearchAllData
    filterMultiStatusTypes: $filterMultiStatusTypes
  ) {
    nodes {
      ...TravelAuthorizationListFields
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
